import React from 'react'
import { Link } from 'react-router-dom'
import ServiceHome from '../../api/serviceHome'

import Topimage from '../../images/service/service-bg.jpg'

const ServiceSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section className={'' + props.hclass}>
      <div className="container p-0">
        <div className="">
          <h2 className="service-title fade_bottom">Our Services</h2>
        </div>

        <div className="service-wrap">
          {ServiceHome.slice(0, 8).map((service, index) => (
            <div className="service-card" key={index}>
              <div className="card-content">
                <img src={service.Icon} alt={service.title} />
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="service-wrap">
          {ServiceHome.slice(0, 8).map((service, item) => (
            <div className="service-card fade_bottom" key={item}>
              <div className="">
                <img src={service.Icon} alt="icon" />

                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  )
}

export default ServiceSection
